module.exports = __webpack_public_path__ + "static/media/the-game-afl-2025-major-prize.c96c9d9a.png";